import { HashRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from './context/ThemeContext'
import { DataProvider } from './context/DataContext'
import AppLayout from './components/layout/AppLayout'

// Pages
import RevenueOverview from './pages/RevenueOverview'
import RevenueCountryReport from './pages/RevenueCountryReport'
import RevenueCustomerReport from './pages/RevenueCustomerReport'
import MarketingSalesOverview from './pages/MarketingSalesOverview'
import MarketingSalesDeals from './pages/MarketingSalesDeals'
import FinancialTargetsOverview from './pages/FinancialTargetsOverview'
import FinancialTargetsMoM from './pages/FinancialTargetsMoM'
import OnboardingDashboard from './pages/OnboardingDashboard'

export default function App() {
  return (
    <ThemeProvider>
      <DataProvider>
        <HashRouter>
          <Routes>
            <Route element={<AppLayout />}>
              <Route path="/" element={<Navigate to="/revenue/overview" replace />} />

              {/* Revenue */}
              <Route path="/revenue/overview" element={<RevenueOverview />} />
              <Route path="/revenue/country" element={<RevenueCountryReport />} />
              <Route path="/revenue/customer" element={<RevenueCustomerReport />} />
              <Route path="/revenue/customer/:customerId" element={<RevenueCustomerReport />} />

              {/* Marketing & Sales */}
              <Route path="/marketing/overview" element={<MarketingSalesOverview />} />
              <Route path="/marketing/deals" element={<MarketingSalesDeals />} />

              {/* Financial Targets */}
              <Route path="/financial/overview" element={<FinancialTargetsOverview />} />
              <Route path="/financial/mom" element={<FinancialTargetsMoM />} />

              {/* Onboarding */}
              <Route path="/onboarding" element={<OnboardingDashboard />} />

              {/* Catch all */}
              <Route path="*" element={<Navigate to="/revenue/overview" replace />} />
            </Route>
          </Routes>
        </HashRouter>
      </DataProvider>
    </ThemeProvider>
  )
}
